import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import scryptJs from 'scrypt-js';
import base64 from 'base64-arraybuffer';
import { stringToArrayBuffer } from './utils';
/**
 *
 * From the Scrypt paper:
 *
 * "100ms is a reasonable upper bound on the delay which should be
 * cryptographically imposed on interactive logins"
 *
 * Pg. 13
 * https://www.tarsnap.com/scrypt/scrypt.pdf
 *
 * With an optimized Scrypt algorithm running on a 3.1 GHz Intel Core i5,
 * N = 32768 is the highest work factor that takes <100ms for the
 * algorithm to run. Thus, it's the latest recommended work factor.
 *
 * Source: https://blog.filippo.io/the-scrypt-parameters/
 *
 * However, we are not running an optimized version of the algorithm on a
 * single machine. Users are running a pure js version written for the browser.
 * Safari, for example, takes >6 seconds to run when N = 32768 on a 2.5 GHz
 * Intel Core i5. A higher end CPU can only shave around 1 second off that time.
 * Further, it takes over 1s to run in Firefox, and over 500ms to run in Chrome.
 * This is an unacceptably slow interactive login delay to impose on users.
 *
 * Thus, we are going with N = 16384 to ensure interactive logins
 * are closer to the reasonable delay the function will impose on users,
 * while still maintaining a high level of security.
 *
 **/

var N = 16384; // 16mb

var r = 8;
var p = 1;
var dkLen = 32;
/**
 * NIST recommendation:
 *
 * "The length of the randomly-generated portion of the salt shall be at least 128 bits."
 *
 * Section 5.1
 * https://nvlpubs.nist.gov/nistpubs/Legacy/SP/nistspecialpublication800-132.pdf
 *
 **/

var SALT_LENGTH = 16;

var generateSalt = function generateSalt() {
  return window.crypto.getRandomValues(new Uint8Array(SALT_LENGTH));
};

var hash = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(passwordString, salt) {
    var passwordHashAlgo,
        passwordArrayBuffer,
        passwordHash,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            passwordHashAlgo = _args.length > 2 && _args[2] !== undefined ? _args[2] : scryptJs.scrypt;
            passwordArrayBuffer = new Uint8Array(stringToArrayBuffer(passwordString));
            _context.next = 4;
            return passwordHashAlgo(passwordArrayBuffer, salt, N, r, p, dkLen);

          case 4:
            passwordHash = _context.sent;
            return _context.abrupt("return", base64.encode(passwordHash));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function hash(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export default {
  generateSalt: generateSalt,
  hash: hash
};